import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/accountSettings/contributions/main/pageContext';

export const ContributionsErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Contributions page (error: ${error})`);
};
